/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_MoreInputs */

const en_filter_more = /** @type {(inputs: Filter_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More`)
};

const de_filter_more = /** @type {(inputs: Filter_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weiteres`)
};

/**
* | output |
* | --- |
* | "More" |
*
* @param {Filter_MoreInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const filter_more = /** @type {((inputs?: Filter_MoreInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_MoreInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_filter_more(inputs)
	return en_filter_more(inputs)
});